/**
 * Synced Media shared block scripts
 * This file gets shared between the
 * theme and editor.
 */
import parent from '../../util/parent'

// set up videos to be handled by sync (returns array of video nodes and null for image nodes)
const setupMedia = (els) => {
	let media = []
	if (els) {
		// for each media
		media = [...els].map((el, i) => {
			const ret = { el }
			// activate the first one (index 0)
			if (!i) {
				el.classList.add('active')
			}
			// prep vids for play/pause functionality (browser errors if they don't have autoplay set)
			const vid = el.querySelector('video')
			if (vid?.autoplay) {
				vid.setAttribute('mute', '')
				vid.setAttribute('playsinline', '')
				vid.removeAttribute('controls')
				vid.removeAttribute('loop')
				ret.vid = vid
			}
			// add this to the list of media
			return ret
		})
	}
	return media
}

// activate/deactivate media
const handleActive = (els, cur) => {
	// for each media item
	els.forEach((el, i) => {
		// determine if is to be active
		const isCur = i === cur
		// play current vid
		if (el.vid && isCur) {
			// set time to 0 then play (browsers seem to have a hard time doing in correct order)
			el.vid.currentTime = 0
			setTimeout(() => {
				el.vid.play()
			}, 1000)
		}
		// add/remove active state (after a bit so playhead is sure to be at 0 for vids)
		setTimeout(() => {
			el.el.classList.toggle('active', isCur)
		}, 20)
	})
}

// apply sync
const sync = (els) => {
	// for each synced element we have
	if (els) {
		els.forEach((el) => {
			// if we have a cycle element within the same parent
			// const parentEl = parent(el, '.wp-block-columns')
			const parentEl = parent(el, '.wp-block-columns')
			if (parentEl) {
				const cycle = parentEl.querySelector('.js-cycle')
				if (cycle) {
					// st up all the media items to sync
					const media = setupMedia(el.querySelectorAll('.basic-media'))
					// look for the cycle data attribute to change index
					const observer = new MutationObserver((mutationsList) => {
						for (const mutation of mutationsList) {
							if (mutation.attributeName === 'data-cur-cycle') {
								// activate/deactive media
								handleActive(media, parseInt(mutation.target.dataset.curCycle))
							}
						}
					})
					observer.observe(cycle, { attributes: true })
				}
			}
		})
	}
}
sync(document.querySelectorAll('.synced-media'))
